export default "__VITE_ASSET__Dlj7ljrk__"